import React, { useState } from "react";
import { Modal, ModalClose } from "@coverme/elements";
import { CTA } from "@coverme/forms";
import { TextArea } from "../FormComponents/TextArea";
import { isNullOrWhitespace } from "../../services/stringService";

export const AddNoteModal = ({ isShown, onClose, onNoteAdded }) => {
    const [noteBody, setNoteBody] = useState("");
    const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
    const onSubmitClicked = () => {
        let noteAddedResponse = null;
        setHasAttemptedSubmit(true);
        if (isNullOrWhitespace(noteBody)) {
            setHasAttemptedSubmit(false);
            return;
        }

        if (onNoteAdded) {
            noteAddedResponse = onNoteAdded(noteBody);
            if (noteAddedResponse?.then) {
                noteAddedResponse.then(() => {
                    setHasAttemptedSubmit(false);
                    setNoteBody("");
                    onClose();
                });
            } else {
                setHasAttemptedSubmit(false);
                setNoteBody("");
                onClose();
            }
        }
    };

    return (
        <Modal hide={onClose} isShowing={isShown} className="notes-modal">
            <div className="modal-title">
                <h3>Add Note</h3>
                <ModalClose hide={onClose} showCloseButton={true} />
            </div>
            <TextArea
                id="notes-text-area"
                title="Note Body"
                onChange={e => setNoteBody(e.currentTarget.value)}
                errorMessage="Required"
                validState={isNullOrWhitespace(noteBody) === true && hasAttemptedSubmit === true ? "invalid" : "valid"}
                placeholder="Enter note body..."
                value={noteBody}
            />
            <div className="submit-buttons">
                <CTA styleType="blue" 
                click={onSubmitClicked}
                disabled={hasAttemptedSubmit}
                >
                    Submit
                </CTA>
            </div>
        </Modal>
    );
};
